import styled from 'styled-components';

import { fontWeight } from '@gaming1/g1-style';

export const MessageValue = styled.span`
  font-weight: ${fontWeight('bold', 'content')};
`;
